import {Injectable} from '@angular/core';
import {BreakpointObserver} from '@angular/cdk/layout';
import {map, shareReplay, startWith} from 'rxjs/operators';
import {Observable} from 'rxjs';

const bootstrapBreakpoints = {
	large: '(max-width: 991px)'
};

@Injectable({
	providedIn: 'root'
})
export class BreakpointService {

	readonly mobile$: Observable<boolean>;
	readonly desktop$: Observable<boolean>;

	constructor(private breakpointObserver: BreakpointObserver) {

		this.mobile$ = this.breakpointObserver.observe(bootstrapBreakpoints.large).pipe(
			map(result => result.matches),
			startWith(this.mobile),
			shareReplay(1)
		);

		this.desktop$ = this.mobile$.pipe(map(mobile => !mobile));
	}

	get mobile(): boolean {
		return this.breakpointObserver.isMatched(bootstrapBreakpoints.large);
	}

	get desktop(): boolean {
		return !this.mobile;
	}
}
